// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selectable-table .v-data-table__checkbox {\n  -webkit-transform: scale(0.625);\n          transform: scale(0.625);\n  -webkit-transform-origin: 50% 80%;\n          transform-origin: 50% 80%;\n  margin: 0px !important;\n}\n.selectable-table tbody tr {\n  cursor: pointer;\n}\n.selectable-table tbody tr.v-data-table__selected {\n  background: #e2f5fb !important;\n}\n.selectable-table .v-data-footer {\n  border-top: none !important;\n}", ""]);
// Exports
module.exports = exports;
